function updateKeyValueFilterArray(currentFilters = [], ...filters) {
  return filters?.reduce(
    (previousValue, currentValue) => {
      const newArray = previousValue?.filter((f) => f.key !== currentValue.key);
      newArray?.push(currentValue);
      return newArray;
    },
    [...currentFilters]
  );
}
export {
  updateKeyValueFilterArray
};
//# sourceMappingURL=keyValueFilter.js.map
